import { useEffect, useRef } from 'react';
import { useField } from '@unform/core';
import {
  Conteiner,
  CheckboxConteiner,
  TextoCheckbox,
  CheckboxesConteiner,
  TextoDeErro,
} from './styles';

export function Checkbox({ titulo, nome, aoAtribuirValor, opcoes = [], desabilitado = false }) {
  const inputRefs = useRef([]);
  const { fieldName, registerField, defaultValue, error } = useField(nome);

  useEffect(() => {
    if (defaultValue !== undefined) {
      inputRefs.current.forEach((inputRef) => {
        if (defaultValue.map((objeto) => objeto.nome).includes(inputRef.value))
          inputRef.checked = true;
        else inputRef.checked = false;
      });
      if (aoAtribuirValor) aoAtribuirValor(defaultValue);
    }
  }, [defaultValue, aoAtribuirValor]);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRefs,
      getValue: (refs) => {
        return refs.current
          .map((inputRef) => (inputRef.checked ? { nome: inputRef.value } : null))
          .filter(Boolean);
      },
      setValue: (refs, id) => {
        const inputRef = refs.current.find((ref) => ref.id === id);
        if (inputRef) {
          inputRef.checked = true;
        }
      },
      clearValue: (refs) => {
        const inputRef = refs.current.find((ref) => ref.checked === true);
        if (inputRef) inputRef.checked = false;
      },
    });
  }, [fieldName, registerField]);

  return (
    <Conteiner>
      {titulo}
      {error && <TextoDeErro>{error}</TextoDeErro>}
      <CheckboxesConteiner>
        {opcoes.map((opcao, index) => (
          <CheckboxConteiner key={`checkbox${nome}${index}`}>
            <input
              type='checkbox'
              ref={(ref) => {
                inputRefs.current[index] = ref;
              }}
              id={`checkbox${nome}${index}`}
              value={opcao.label}
              name={nome}
              disabled={desabilitado}
            />
            <TextoCheckbox htmlFor={`checkbox${nome}${index}`} key={`checkbox${nome}${index}`}>
              {opcao.label}
            </TextoCheckbox>
          </CheckboxConteiner>
        ))}
      </CheckboxesConteiner>
    </Conteiner>
  );
}
